export const GET_CASHPASS_EXCLUSIONS = 'GET_CASHPASS_EXCLUSIONS';
export const GET_CASHPASS_EXCLUSIONS_SUCCESS = 'GET_CASHPASS_EXCLUSIONS_SUCCESS';
export const GET_CASHPASS_EXCLUSIONS_ERROR = 'GET_CASHPASS_EXCLUSIONS_ERROR';
export const RESET_CASHPASS_EXCLUSIONS = 'RESET_CASHPASS_EXCLUSIONS';
